import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('pqPowAttrStore', Object.keys(getters)),
	...mapState('pqPowAttrStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('pqPowAttrStore', Object.keys(actions)),
	...mapMutations('pqPowAttrStore', Object.keys(mutations))
};
